export default "__VITE_ASSET__DTQH20dr__"